import party from "party-js"

export default function confetti(origin) {
  party.confetti(origin, {
    count: party.variation.range(200, 400),
    size: party.variation.range(0.8, 1.2),
  })
}
